define(
    'viewmodels/app/analytics/index',[
        'plugins/router', 'atn/atn', 'dataSource/customerDetails', 'dataSource/timeData',
        'knockout', 'lodash', 'jquery', 'dataSource/analytics/analyticsRegistry',
        '../__print', './__isAnalyticsLoading', './__settings', './__printCharts',
        'moment', '../__allCharts','dataSource/userPreferences', 
        '../components/__csvDownloadForm', '../__config','../__subrouter',
        '../../../chartApi/filters'
    ],
    function(rootRouter, atn, customerDetails, timeData, ko, _, $,
        analyticsRegistry, printConfig, isAnalyticsLoading, settings,
        printChart, moment, allCharts, userPreferences, csvDownloadForm, config, router,
        filters) {
        'use strict';

        var dataGenerationDate = ko.observable(null);

        var scrollBarPosition = ko.observable(0);

        var dashboardOptions = {
            schedule: {
                create: initReportCreationForm,
                title: atn.config.messages.graphs.actions.scheduleReport
            },
            csv: {
                download: initDownloadCsvForm,
                title: atn.config.messages.graphs.actions.downloadCsv
            },
            printChart: printChart
        };

        const globalDurationFilter = (function() {
            const messages = atn.config.messages.graphs.globalDurationFilter;
            const gdf = filters.createFilter(matrixCharts.$c.filters.DURATION, null, null);
            gdf.label = messages.label;
            gdf.displayText = ko.observable(messages.defaultText);
            gdf.customFilter.dataAvaibilityDate = ko.observable(gdf.customFilter.dataAvaibilityDate); // so that we can change it later
            gdf.onChange(applyGlobalDurationToAllCharts);
            return gdf;
        }) ();

        printChart.print = print;
        
        allCharts.activeDashboard.subscribe(function(newId){
            if(newId){
                if(newId !== userPreferences.allUserPreferences().ACTIVE_DASHBOARD){
                    //update ACTIVE_DASHBOARD in user preferences in memory before 
                    //making the API call to save it
                    //because loadCharts() will not wait for updateUserPreferences() to complete
                    var tmpAllUserPreferences = userPreferences.allUserPreferences();
                    tmpAllUserPreferences[userPreferences.ACTIVE_DASHBOARD] = newId;
                    userPreferences.allUserPreferences(tmpAllUserPreferences);

                    userPreferences.updateUserPreferences({keyString: userPreferences.ACTIVE_DASHBOARD, valueString: newId});
                }
                allCharts.loadCharts();
                var promise = timeData.getLatestDbTimeBoundary(true);
                promise.done(function() {
                    correctTimeBoundariesForGlobalDurationFilter();
                    dataGenerationDate(moment(timeData.timeBoundary()).format(atn.config.dayGeneratedOnFormat));
                    _.delay(startChartRendering, 300);
                });
                promise.fail(function(xhr) {
                    if(xhr.status !== 403){
                        _.defer(rootRouter.navigate, '#site/failure/dataFetch');    
                    }
                });
            }
        });

        return {
            numLoading: analyticsRegistry.numLoading,
            printConfig: printConfig,
            messages: atn.config.messages,
            dashboardList: allCharts.dashboardList,
            activeDashboard: allCharts.activeDashboard,
            activeDashboardName: allCharts.activeDashboardName,
            activate: activate,
            setActiveDashboard: setActiveDashboard,
            isAnalyticsLoading: isAnalyticsLoading,
            dashboardOptions: dashboardOptions,
            globalDurationFilter: globalDurationFilter,
            printChart: printChart,
            dataGenerationDate: dataGenerationDate,
            dataGenerationDateMsg: atn.config.messages.navbar.dataGenerationDate,
            isInternetExplorer: atn.utils.isInternetExplorer,
            scrollBarPosition: scrollBarPosition,
            dashboardChartList: allCharts.dashboardChartList
        };

        /**
         * [activate This function is the activate function of the viewmodel. Whenever the route is invoked this function gets triggered]
         * @return {promise}         [the promise for the activation of the viewModel]
         */
        function activate() {
            var dashboardsPromise = allCharts.loadDashboards(); // this will trigger allCharts.activeDashboard.subscribe
            
            dashboardsPromise.fail(function() {
                _.defer(rootRouter.navigate, '#site/failure/dataFetch');    
            });
        }

        /**
         * [startChartRendering start the rendering of all the charts by initiating the API calls process.]
         * @return {undefined}
         */
        function startChartRendering() {
            allCharts.dashboardChartList().forEach(function(chart) {
                chart.start();
            });
        }

        function print() {
            return printChart.printCharts(allCharts.dashboardChartList());
        }

        function initReportCreationForm() {
                router.navigate("#app/schedule/new/CHART");
        }

        function initDownloadCsvForm(){
            csvDownloadForm.initCsvDownloadForm();   
        }
        
        function setActiveDashboard(dashboard){
            allCharts.activeDashboard(dashboard.id);
        }

        /**
         * This function will correct the time boundaries of the custom filter part of
         * the global duration filter.
         * NOTE: This does NOT result in application of the filter.
         */
        function correctTimeBoundariesForGlobalDurationFilter() {
            const gdf = globalDurationFilter;
            const timeBoundary = moment(timeData.timeBoundary());
            gdf.customFilter.dataAvaibilityDate(timeBoundary.format(atn.config.dayGeneratedOnFormat));
            gdf.customFilter.startDate(timeBoundary._d);
            gdf.customFilter.endDate(timeBoundary._d);
        }

        /**
         * Applies the global duration value to all charts
         */
        function applyGlobalDurationToAllCharts() {
            const filtersConfig = matrixCharts.$c.filters;
            const gdf = globalDurationFilter;
            gdf.displayText(gdf.selectedChoiceText());
            const selectedChoiceId = gdf.selectedChoice();
            const isCustomCase = (selectedChoiceId === filtersConfig.DURATION.custom);
            const startDate = gdf.customFilter.startDate();
            const endDate = gdf.customFilter.endDate();

            allCharts.dashboardChartList().forEach((chart) => {
                // Either durationFilter or dateFilter will be applicable
                const durationFilter = chart.filters.find((filter) => {
                    return (filter.id === filtersConfig.DURATION.id);
                });
                if (durationFilter) {
                    if (isCustomCase) {
                        applyCustomDuration(durationFilter, startDate, endDate);
                    } else {
                        durationFilter.changeDuration({ id: selectedChoiceId });
                    }
                }
                const dateFilter = chart.filters.find((filter) => {
                    return (filter.id === filtersConfig.DATE.id);
                });
                if (dateFilter) {
                    if (isCustomCase) {
                        applyCustomDate(dateFilter, endDate);
                    } else {
                        dateFilter.changeDate({ id: "latest" });
                    }
                }
            });
        }

        /**
         * Applies given custom duration to given chart filter
         */
        function applyCustomDuration(chartFilter, startDate, endDate) {
            chartFilter.selectedChoice(matrixCharts.$c.filters.DURATION.custom);
            chartFilter.customFilter.startDate(startDate);
            chartFilter.customFilter.endDate(endDate);
            chartFilter.customFilter.isShown(true);
            // isShown is set as true, coz below trigger inverts the isShown state
            chartFilter.customFilter.triggerUpdate();
        }

        /**
         * Applies given custom date to given chart filter
         */
        function applyCustomDate(chartFilter, date) {
            chartFilter.selectedChoice(matrixCharts.$c.filters.DATE.custom);
            chartFilter.customFilter.date(date);
            chartFilter.customFilter.isShown(true);
            // above shown is set as true, coz below trigger inverts the shown state
            chartFilter.customFilter.triggerUpdate();
        }

    });

